import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";

const storage = getStorage();

export const uploadEmployeeAttachment = async (
  employeeId: string,
  file: File,
) => {
  const uniqueName = `${crypto.randomUUID()}-${file.name}`;

  const storageRef = ref(storage, `employees/${employeeId}/${uniqueName}`);

  // Upload to Firebase Bucket
  const snapshot = await uploadBytes(storageRef, file);

  // Public URL
  const downloadURL = await getDownloadURL(snapshot.ref);

  const now = new Date().toISOString();

  return {
    name: file.name,
    path: snapshot.ref.fullPath,
    url: downloadURL,
    contentType: file.type,
    uploadedAt: now,
    size: file.size,
  };
};

export const deleteEmployeeAttachment = async (storagePath: string) => {
  await deleteObject(ref(storage, storagePath));
};
